import axios from "axios";
import { ApiURL } from "../utils/constants";

const getLandingPageInfo = async (email) => {
  return axios.get(`${ApiURL}/landing-page/info`);
};

export { getLandingPageInfo };
